import React from "react";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";
import { Footer } from "../../../components/Footer";
import Logout from "../../../components/Logout";

function ManageAccountPage() {
  const { t } = useTranslation();
  const {search} = useLocation()
  const isAndroid = search === "?platform=android"
  return (
    <div className="main">
      <Logout />
      <div className="msd__header__logo"></div>
      <div className="choose-plan">
        <div className="manage-account-text">
          {t(`You’ve subscribed in the ${isAndroid ? "Google Play Store" : "Apple App Store"}. Please manage your subscription from there.`)}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ManageAccountPage;
